import { Component, HostListener, Inject, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-custom-delete',
  templateUrl: './custom-delete.component.html',
  styleUrls: ['./custom-delete.component.scss']
})
export class CustomDeleteComponent {
  srcHeight: number = 0;
  srcWidth: number = 0;
  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<CustomDeleteComponent>,
    // private _bottomSheetRef: MatBottomSheetRef<CustomDeleteComponent>,
    // @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public bottomSheetData:any,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.getScreenSize();
    // if(this.srcWidth<475){
    //     this.data=bottomSheetData;
    //     
    // }

  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: any) {
    this.srcHeight = window.innerHeight;
    this.srcWidth = window.innerWidth;
    ////
  }

  deleteoption() {
    this.dialogRef.close({ response: 'success' })
  }
  cancel() {
    this.dialogRef.close({ response: 'cancel' });
    // else{
    //   this. _bottomSheetRef.dismiss();
    // }
  }
}
